export var useCommonDatePickerActionButtons = function useCommonDatePickerActionButtons(_ref, _ref2) {
  var applyValue = _ref.applyValue,
    clearValue = _ref.clearValue,
    closeDropdown = _ref.closeDropdown,
    enableApplyButton = _ref.enableApplyButton;
  var enableClearSelectionButton = _ref2.enableClearSelectionButton,
    enableCloseOnSelect = _ref2.enableCloseOnSelect,
    enableTodayButton = _ref2.enableTodayButton;
  var showActions = !!(enableApplyButton || enableTodayButton || enableClearSelectionButton);
  var reallyEnableCloseOnSelect = !enableApplyButton && enableCloseOnSelect === true;
  return {
    enableCloseOnSelect: reallyEnableCloseOnSelect,
    showActions: showActions,
    actionBarProps: {
      enableApplyButton: enableApplyButton,
      enableClearSelectionButton: enableClearSelectionButton,
      enableTodayButton: enableTodayButton,
      applyValue: applyValue,
      clearValue: clearValue,
      setClose: closeDropdown,
      enableCloseOnSelect: reallyEnableCloseOnSelect,
      onTodayButtonClick: function onTodayButtonClick() {}
    }
  };
};